export default "__VITE_ASSET__C21Jj_GR__"